import { useEffect, useMemo, useState } from "react"
import {
  useDebugStack,
  setDebugStackForNextSubscription,
} from "../lib/reflux/monitoring-hooks";

// todo: shape is ideal, but the getter will work for now

/**
 * Getter function to supply to the hook. Expected use is to get data from the reflux store passed to the callback, 
 * and then calling the update (useState setter) to opt into accepting changes. This api will probably change at some point.
 * @callback getter
 * @param {Reflux.Store} storeData - The data from the store.
 * @param {React.Dispatch<React.SetStateAction<any>>} update - The callback function to set the data.
 */

/**
 * Custom hook to get data from a Reflux store. 
 * 
 * @param {getter} getter - The function to get data from the store.
 * @param {Reflux.Store} store - The Reflux store to listen to.
 * @returns {any} - The data from the store.
 */
const useStoreData = (getter, store) => {
  const [data, setData] = useState(undefined);
  const [previousData, setPreviousData] = useState(undefined);

  // Capture stack during render (when calling component is on the stack)
  const debugStack = useDebugStack();

  const setter = (newData) => {
    setPreviousData(data);
    setData(newData);
  };

  useEffect(() => {
    getter(store?.state, setter);
    // Set the debug stack for memory tracking before subscribing
    setDebugStackForNextSubscription(debugStack);
    const unsubscribe = store.listen((storeData) => {
      // todo: some equality check for non scalar values?
      getter(storeData, setter);
    });

    return () => unsubscribe();
  })

  return useMemo(() => [data, previousData], [data]);
}

export default useStoreData;